import type { ReactNode } from 'react';

export const symbol_package: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m380-548 80-40q9.51-5 19.76-5 10.24 0 20.24 5l80 40v-232H380v232Zm-60 268q-17 0-28.5-11.5T280-320q0-17 11.5-28.5T320-360h120q17 0 28.5 11.5T480-320q0 17-11.5 28.5T440-280H320ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-660v600-600Zm0 600h600v-600H640v280q0 17.5-14 26.25t-29 .75l-117-58-117 58q-15 8-29-.75T320-500v-280H180v600Z"
		/>
	</svg>
);
